import {Component, computed, input, output, ChangeDetectionStrategy} from "@angular/core"
import {PricingNode, ConditionalAmountGroupNode, ConditionalAmountNode, PricingContext, PriceContainer, PricedItemNode} from "@cm/pricing"
import {ConditionalAmountGroupNodeComponent} from "@pricing/components/node-visualizers/conditional-amount-group-node/conditional-amount-group-node.component"
import {ConditionalAmountNodeComponent} from "@pricing/components/node-visualizers/conditional-amount-node/conditional-amount-node.component"
import {PriceContainerNodeComponent} from "@pricing/components/node-visualizers/price-container-node/price-container-node.component"
import {PricedItemNodeComponent} from "@pricing/components/node-visualizers/priced-item-node/priced-item-node.component"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-price-node-visualizer",
    templateUrl: "./price-node-visualizer.component.html",
    styleUrls: ["./price-node-visualizer.component.scss"],
    imports: [ConditionalAmountGroupNodeComponent, ConditionalAmountNodeComponent, PriceContainerNodeComponent, PricedItemNodeComponent],
})
export class PriceNodeVisualizerComponent {
    readonly $node = input.required<PricingNode>({alias: "node"})
    readonly $pricingContext = input.required<PricingContext>({alias: "pricingContext"})
    readonly $isPricedItemNode = computed<boolean>(() => this.$node() instanceof PricedItemNode)
    readonly $isPriceContainerNode = computed<boolean>(() => this.$node() instanceof PriceContainer)
    readonly $isAmountGroupNode = computed<boolean>(() => this.$node() instanceof ConditionalAmountGroupNode)
    readonly $isAmountNode = computed<boolean>(() => this.$node() instanceof ConditionalAmountNode)
    readonly conditionRemoved = output<void>()
}
